import * as t from 'io-ts';
import { z } from 'zod';

/* UNIVERSE TYPE */
export const UniverseIO = t.union([
    //star template
    t.literal('akbets'),
    t.literal('bestodds'),
    t.literal('betwright'),
    t.literal('bresbet'),
    t.literal('dragonbet'),
    t.literal('energy'),
    t.literal('gentlemanjim'),
    t.literal('londonbet'),
    t.literal('mcbookie'),
    t.literal('planetsportbet'),
    t.literal('pricedup'),
    t.literal('star'),
    t.literal('betstgeorge'),
]);

/* UNIVERSE TYPE ZOD*/
export const UniverseZod = z.union([
    z.literal('akbets'),
    z.literal('bestodds'),
    z.literal('betwright'),
    z.literal('bresbet'),
    z.literal('dragonbet'),
    z.literal('energy'),
    z.literal('gentlemanjim'),
    z.literal('londonbet'),
    z.literal('mcbookie'),
    z.literal('planetsportbet'),
    z.literal('pricedup'),
    z.literal('star'),
    z.literal('betstgeorge'),
]);

export type UniverseType = t.TypeOf<typeof UniverseIO>;

export const getAllUniverse = (): Array<UniverseType> => {
    return [
        'akbets',
        'bestodds',
        'betwright',
        'bresbet',
        'dragonbet',
        'energy',
        'gentlemanjim',
        'londonbet',
        'mcbookie',
        'planetsportbet',
        'pricedup',
        'star',
        'betstgeorge',
    ];
};

/**
 * @deprecated - Please use the getAllUniverse function
 */
export const getAllUniverseStr = (): Array<string> => {
    return getAllUniverse();
};
